import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Bandeau promo au-dessus du header — mini affiches (artistes à la une,
 *  partenariats de marques) gérées depuis l'admin. Rotation auto toutes les 6 s. */
export default function PromoStrip() {
    const [slides, setSlides] = useState([]);
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        api.get("/promo-slides").then(({ data }) => setSlides(data || [])).catch(() => {});
    }, []);

    useEffect(() => {
        if (slides.length < 2) return;
        const t = setInterval(() => setIdx((i) => (i + 1) % slides.length), 6000);
        return () => clearInterval(t);
    }, [slides.length]);

    if (slides.length === 0) return null;
    const s = slides[idx];
    const inner = (
        <div className="relative h-16 md:h-20 overflow-hidden bg-[#0a0a0a] border-b border-[#1c1c1c]" data-testid="promo-strip">
            <img decoding="async" loading="lazy" src={s.image_url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover blur-xl scale-110 opacity-40" />
            <img decoding="async" loading="lazy" src={s.image_url} alt={s.title || "Publicité"} className="absolute inset-0 w-full h-full object-contain" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60 pointer-events-none" />
            {s.title && (
                <p className="absolute inset-y-0 left-4 flex items-center text-xs md:text-sm font-semibold text-white drop-shadow">{s.title}</p>
            )}
            {slides.length > 1 && (
                <div className="absolute bottom-1 right-3 flex gap-1">
                    {slides.map((_, i) => (
                        <span key={i} className={`w-1.5 h-1.5 rounded-full ${i === idx ? "bg-[#00d97e]" : "bg-white/40"}`} />
                    ))}
                </div>
            )}
        </div>
    );
    return s.link_url ? (
        <a href={s.link_url} target={s.link_url.startsWith("/") ? "_self" : "_blank"} rel="noreferrer" data-testid="promo-strip-link">{inner}</a>
    ) : inner;
}
